import theme from '../../../themes/colors';

export const getGroupCardColor = (id: string) => {
  if (!id || typeof id !== 'string' || id.trim() === '')
    return theme.cofeeGreyBlue2;

  const bgColorList = [
    theme.cofeeBlue2,
    theme.cofeeOrange2,
    theme.cofeePurple1,
    theme.cofeeGreen1,
    theme.cofeeRed1,
    theme.cofeeYellow1,
    theme.cofeeViolet1
  ];

  let hash = 0;
  for (let i = 0; i < id.length; i += 1) {
    hash = (hash * 31 + id.charCodeAt(i)) % 2_147_483_647;
  }

  const index = Math.abs(hash) % bgColorList.length;
  return bgColorList[index];
};

export const getGroupCardTextColor = (bgColor: string) => {
  const colorMapping = {
    [theme.cofeeBlue3]: theme.cofeeBlue7,
    [theme.cofeeOrange2]: theme.cofeeOrange8,
    [theme.cofeePurple1]: theme.cofeePurple7,
    [theme.cofeeGreen1]: theme.cofeeGreen10,
    [theme.cofeeRed1]: theme.cofeeRed10,
    [theme.cofeeYellow1]: theme.cofeeYellow10,
    [theme.cofeeViolet1]: theme.cofeeViolet7,
    [theme.cofeeGreyBlue2]: theme.cofeeGreyBlue6
  };

  return colorMapping[bgColor] || theme.cofeeGreyBlue6;
};
